// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"173":"2534e394","730":"5da15abd","772":"4f034e44"}[chunkId] + ".css";
};